/** MBA 论文默认目录（映射到底层 act/chapter/scene；标题不含「第N章」，序号由目录/稿面另行展示） */
export const MBA_THESIS_CHAPTERS = [
  {
    title: '绪论',
    goal: '交代实践背景、研究问题、研究意义与全文结构。',
  },
  {
    title: '文献综述与理论基础',
    goal: '梳理相关理论与既有研究，明确分析框架与研究空白。',
  },
  {
    title: '研究方法与设计',
    goal: '说明案例/样本、数据来源、分析步骤与信度效度。',
  },
  {
    title: '案例/数据分析',
    goal: '按研究问题呈现证据与发现，避免流水账。',
  },
  {
    title: '讨论与管理启示',
    goal: '把发现回扣理论与实践，给出可执行建议。',
  },
  {
    title: '结论与展望',
    goal: '总结贡献、局限与后续研究。',
  },
] as const;

export const MBA_ACT_TITLE = '论文目录';
